import angular from 'angular';

import { LoginService } from './login.service';
import { LoginComponent } from './login.component';
import { LoginFormComponent } from "./loginForm.component";

export const LoginModule = angular
    .module('mmsApp.pages.login', [
    ])
    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';
        $stateProvider
            .state('pages.login', {
                data: {
                    isAuthRequired: false,
                },
                // url: '/login',
                params: {
                    emailAddress: ''
                },
                component: LoginComponent.name,
                resolve: {
                    emailAddress: ($transition$) => {
                        return $transition$.params().emailAddress;
                    },
                    onLogin: ($transition$, UtilService) => {
                        return () => {
                            UtilService.redirectBackToPrev($transition$, 'pages');
                        };
                    }
                }
            });
    })
    .service('LoginService', LoginService)
    .component(LoginComponent.name, LoginComponent.component)
    .component(LoginFormComponent.name, LoginFormComponent.component)
    .name
    ;



// WEBPACK FOOTER //
// ./src/app/pages/login/login.module.js